export default "__VITE_ASSET__BU1Ug5Gs__"